export const SIMILAR_PRODUCTS_DONE = 'SIMILAR_PRODUCTS_DONE'
export const SIMILAR_PRODUCTS_START = 'SIMILAR_PRODUCTS_START'
export const SIMILAR_PRODUCTS_ERROR = 'SIMILAR_PRODUCTS_ERROR'
export const SIMILAR_PRODUCTS_RESET = 'SIMILAR_PRODUCTS_RESET'

export const SIMILAR_PRODUCTS_COUNT = 16
export const SIMILAR_PRODUCT_LIST_BATCH_SIZE = 20
export const SIMILAR_PRODUCTS_SKELETON_COUNT = 4
